// Shared mini card for pool board / lists. Unified identity + quick actions.
// Fáze 2: draggable + notes/tags indicator + edit button.
import React from "react";
import { Link } from "react-router-dom";
import { Trash, ArrowSquareOut, NotePencil } from "@phosphor-icons/react";
import { POOL_STATUSES } from "../../lib/lab-api";

export const PlayerMiniCard = ({ entry, onStatusChange, onRemove, onEditNotes, draggable }) => (
    <div className="border border-white/10 bg-black/40 p-2.5 space-y-1.5 hover:border-fa-mint/30 transition-colors"
         draggable={draggable ? "true" : undefined}
         onDragStart={draggable ? (e) => { e.dataTransfer.setData("text/pool-entry", entry.id); e.dataTransfer.effectAllowed = "move"; } : undefined}
         style={draggable ? { cursor: "grab" } : undefined}
         data-testid={`pool-card-${entry.fpl_id}`}>
        <div className="flex items-start justify-between gap-2">
            <Link to={`/players/${entry.fpl_id}`} className="min-w-0 group">
                <div className="font-display font-bold text-sm truncate group-hover:text-fa-mint transition-colors">
                    {entry.name}
                    <ArrowSquareOut size={10} className="inline ml-1 opacity-40" />
                </div>
                <div className="font-mono text-[9px] uppercase text-white/45 truncate">
                    {entry.team} · {entry.position}{entry.price != null ? ` · £${entry.price}` : ""}
                </div>
            </Link>
            <div className="flex gap-1 flex-shrink-0">
                {onEditNotes && (
                    <button type="button" onClick={() => onEditNotes(entry)} title="Poznámky & tagy"
                            data-testid={`pool-notes-${entry.fpl_id}`}
                            className={`p-0.5 ${entry.notes?.note || entry.notes?.reason || entry.tags?.length ? "text-fa-sky" : "text-white/30 hover:text-fa-sky"}`}>
                        <NotePencil size={12} />
                    </button>
                )}
                <button type="button" onClick={() => onRemove(entry)} title="Odebrat z poolu"
                        data-testid={`pool-remove-${entry.fpl_id}`}
                        className="text-white/30 hover:text-red-400 p-0.5">
                    <Trash size={12} />
                </button>
            </div>
        </div>
        {entry.news && (
            <div className="font-mono text-[8px] text-orange-300/80 truncate" title={entry.news}>⚠ {entry.news}</div>
        )}
        {entry.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1">
                {entry.tags.slice(0, 3).map((t) => (
                    <span key={t} className="font-mono text-[7px] uppercase px-1 py-0.5 bg-fa-violet/20 text-fa-sky">{t}</span>
                ))}
                {entry.tags.length > 3 && <span className="font-mono text-[7px] text-white/40">+{entry.tags.length - 3}</span>}
            </div>
        )}
        <select value={entry.status} onChange={(e) => onStatusChange(entry, e.target.value)}
                data-testid={`pool-status-${entry.fpl_id}`}
                className="w-full bg-black/60 border border-white/15 font-mono text-[9px] uppercase px-1.5 py-1 focus:outline-none focus:border-fa-mint">
            {POOL_STATUSES.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
        </select>
    </div>
);
